import { render, staticRenderFns } from "./TeacherStatistics.vue?vue&type=template&id=a6393f52&scoped=true"
import script from "./TeacherStatistics.vue?vue&type=script&lang=js"
export * from "./TeacherStatistics.vue?vue&type=script&lang=js"
import style0 from "./TeacherStatistics.vue?vue&type=style&index=0&id=a6393f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6393f52",
  null
  
)

export default component.exports